export function getKategorije(kategorije) {
    return { type: 'GET_KATEGORIJE', kategorije };
}
